import { useState, useCallback } from 'react';
import { firstError } from '@/utils/validators';

// schema: { fieldName: [validatorFns] }
export function useFormValidation(schema) {
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const validateField = useCallback((name, value) => {
    const msg = firstError(value, schema[name] || []);
    setErrors(prev => ({ ...prev, [name]: msg }));
    return msg;
  }, [schema]);

  const handleBlur = useCallback((name, value) => {
    setTouched(prev => ({ ...prev, [name]: true }));
    validateField(name, value);
  }, [validateField]);

  const validateAll = useCallback((formData) => {
    const next = {};
    let ok = true;
    Object.keys(schema).forEach(name => {
      const msg = firstError(formData[name], schema[name]);
      next[name] = msg;
      if (msg) ok = false;
    });
    setErrors(next);
    setTouched(Object.keys(schema).reduce((a, k) => ({ ...a, [k]: true }), {}));
    return ok;
  }, [schema]);

  const applyServerErrors = useCallback((serverErrors = []) => {
    const next = {};
    serverErrors.forEach(e => { if (e.field) next[e.field] = e.message; });
    setErrors(prev => ({ ...prev, ...next }));
    setTouched(prev => ({ ...prev, ...Object.keys(next).reduce((a, k) => ({ ...a, [k]: true }), {}) }));
  }, []);

  const showError = (name) => (touched[name] ? errors[name] : '') || '';

  return { errors, touched, validateField, handleBlur, validateAll, applyServerErrors, showError };
}
